import styled, { keyframes } from "styled-components";

const menuAnimation = keyframes`
  0%{
    opacity: 0.6;
    transform: translateY(-15px);
  }
  100%{
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  position: relative;
  outline: none;

  .menu {
    animation: ${menuAnimation} 0.5s ease;
    animation-direction: alternate;
    position: ${props => (props.fixed ? "fixed" : "absolute")};
    top: ${props => props.top};
    right: ${props => (props.menuLeft ? "auto" : props.right)};
    left: ${props => (props.menuLeft ? props.menuLeft : "auto")};
    z-index: 10000000;
  }

  .inner {
    display: flex;
    flex-direction: column;
    align-items: ${props => (props.menuLeft ? "flex-start" : "flex-end")};
  }

  .clickable {
    cursor: pointer;
  }

  .triangle {
    margin-bottom: ${({ iconStyle }) => (iconStyle ? "0px" : "-3px")};
    margin-top: ${({ iconStyle }) => (iconStyle ? "-3px" : "0px")};
    width: 21px;
    height: 14px;
    margin-right: ${({ iconStyle }) => (iconStyle ? "-4px" : "10px")};
  }
`;

export const Icon = styled.img`
  margin: 19px;
  cursor: pointer;
`;
